export default {
  icon: 'mdi-dolly',
  text: 'Representantes',
  permissions: [
    { name: 'representativeBrandIndex', text: 'Visualizar representantes', value: 0 },
    { name: 'representativeBrandCreateEdit', text: 'Cadastrar/Editar representantes', value: 0 }
  ]
}